import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { initialize, reduxForm, Field } from 'redux-form';
import { useDispatch, useSelector } from 'react-redux';
import M from 'materialize-css';

import FormButton from '../../../components/UI/FormButton';
import { 
    renderFieldTwoColumns 
} from '../../../components/UI/Fileds';

import { setBookSectionFilter } from '../../../actions/bookSection';
import { max4digits } from '../../../helpers/validators';

const BookSectionSearchForm = ({ submitting, handleSubmit }) => {

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const { filter } = useSelector(state => state.bookSection);

    useEffect(() => {

        const elems = document.querySelectorAll('.collapsible');
        M.Collapsible.init(elems, {});
        
        dispatch(
            initialize('bookSectionSearchForm', filter)
        );

    }, [dispatch, filter]);
    
    const handleReset = () => {
        dispatch(
            setBookSectionFilter({})
        );
    };

    const handleSearch = (values) => {
        const collapsibles = document.getElementsByClassName('collapsible-search-form');
        const instance = M.Collapsible.getInstance(collapsibles[0]);
        instance.close();

        dispatch(
            setBookSectionFilter(values)
        );
    }

    const renderForm = () => {
        return (
            <form className="search-form" onSubmit={ handleSubmit(handleSearch) }>

                {/* Campos del formulario */}
                <div className="row margin">
                    <Field type="text" name="nombre" id="nombre" 
                        label={ t('screens-book-section-list-nombre') } 
                        component={ renderFieldTwoColumns } 
                        icon="text_fields" 
                        key="nombre" 
                    />

                    <Field type="number" name="codigo" id="codigo" 
                        label={ t('screens-book-section-list-codigo') } 
                        component={ renderFieldTwoColumns } 
                        icon="label_outline" 
                        key="codigo" 
                        normalize={ max4digits }
                    />
                </div>

                {/* Botones del formulario */}
                <div className="row">
                    <div className="input-field col s12">
                        <FormButton type="submit"
                            title={ t('search-form-button-title') }
                            disabled={ submitting }
                        />

                        <FormButton type="reset"
                            title={ t('reset-form-button-title') }
                            disabled={ submitting }
                            onClick={ handleReset }
                        />
                    </div>
                </div>

            </form>
        );
    };

    return (
        <ul className="collapsible popout collapsible-search-form">
            <li>
                <div className="collapsible-header">
                    <i className="material-icons">tune</i> { t('filter-title') }
                </div>
                <div className="collapsible-body">
                    { renderForm() }
                </div>
            </li>
            
        </ul>
    );
};

const validate = (values) => ({});

export default reduxForm({
    form: 'bookSectionSearchForm',
    validate: validate,
    destroyOnUnmount: false
})(BookSectionSearchForm);